<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-primary.new-entry-channel(v-if="isAdmin" :to="{name: 'entryChannelNew'}")
        i.fa.fa-plus
        span.ml5 New Entry Channel

    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Id
        th Alias
        th Owner
        th Shared
        th Translations
        th
      tr(v-for="es in entryChannels")
        td {{es.id}}
        td(v-if="es.alias")
          i.fa.fa-globe
          |
          | {{es.alias}}
        td(v-if="es.phonenumber")
          i.fa.fa-phone
          |
          | {{es.phonenumber}}
          span(v-if="es.prefix")
            em.text-muted    with prefix {{es.prefix}}
        td(v-if="!es.alias && !es.phonenumber")
          em.text-muted No description
        td
          div(v-for="o in es.owner") {{o.organization.adminUser}}
        td
          div(v-if="es.owner.length !== 1") Yes
          div(v-else) No
        td
          div(v-for="t in es.translations.translation") {{t.country | countryName}}
        td.actions
          a.btn-view(@click="goToEntryChannel(es.id)") View
</template>

<script>
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'
import { countryName } from '@/filters/filters'
import auth from '@/service/AuthService'

export default {
  data: () => ({
    entryChannels: []
  }),
  methods: {
    fetchData(page) {
      const req = page.maxOffsetRequest()
      return Core.listEntryChannels(req)
        .then((resp) => {
          this.entryChannels = resp.data.entryChannels.entryChannel
          return resp.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    goToEntryChannel(id) {
      this.$router.push({ name: 'entryChannel', params: { id } })
    }
  },
  computed: {
    isAdmin() {
      if (auth.isAdmin()) {
        return true
      }
      return false
    }
  },
  components: {
    DataGrid
  },
  filters: {
    countryName
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/validation/entrychannel/Entrychannels.vue